module.exports = __webpack_public_path__ + "img/themerkle.2d50b884.png";